import { Vue, Component, Prop } from 'vue-property-decorator'
import ImageElement from '~/components/element/ImageElement'
import BasketSvg from '~/assets/svg/product-basket.svg?inline'
import BasketSuccessSvg from '~/assets/svg/product-success.svg?inline'
import s from '~/utils/s'
import loc from '~/utils/loc'
import LinkItem from '~/types/LinkItem'
import NavBackLink from '~/components/element/NavBackLink'
import SwitchElement from '~/components/element/SwitchElement'
import BellSvg from '~/assets/svg/bell.svg?inline'
import BasketNumber from '~/components/element/BasketNumber'

@Component
export default class ProductFixed extends Vue {
  @Prop({ type: Object })
  readonly backLink?: LinkItem

  isScroll: boolean = false;
  currentYOffset: number = 0;

  mounted () {
    window.addEventListener('scroll', this.scrollHandler)
    this.scrollHandler()
  }

  beforeDestroy () {
    window.removeEventListener('scroll', this.scrollHandler)
  }

  get isBasket () {
    return s(this.$store).basket.items.find(e => e.product.id === s(this.$store).productPage.id) !== undefined
  }

  get code () {
    return s(this.$store).productPage.code
  }

  get isDiscount (): boolean {
    return s(this.$store).productPage.price < s(this.$store).productPage.basePrice
  }

  get isAvailable (): boolean {
    return s(this.$store).productPage.available > 0
  }

  addToBasket () {
    if (this.isBasket) {
      this.$router.push(loc(this.$store, {
        name: 'basket'
      }))
    } else {
      s(this.$store).basket.add(s(this.$store).productPage.id)
    }
  }

  scrollHandler () {
    this.isScroll = this.currentYOffset < window.pageYOffset
    this.currentYOffset = window.pageYOffset
  }

  renderNavBackLink () {
    return (
      <div class="product-page-fixed__back-link">
        <NavBackLink {...{
          props: {
            link: this.backLink
          }
        }} />
      </div>
    )
  }

  get isWaitingList (): boolean {
    return s(this.$store).waitingList.ids.map(id => id.id).includes(s(this.$store).productPage.id)
  }

  get isWaitingListModifier (): any {
    if (this.isWaitingList) {
      return ['waiting_selected']
    }
    return []
  }

  async addToWaitingList (value: boolean) {
    if (value !== this.isWaitingList) {
      await s(this.$store).waitingList.changeProduct(s(this.$store).productPage.id)
    }
  }

  scopedSlotsWaitingListButton () {
    return (
      <div class="product-page-fixed__waiting-list-button-content">
        <div class="product-page-fixed__waiting-list-button-text">
          Сообщим о поступлении
        </div>
        <div class="product-page-fixed__waiting-list-button-icon">
          <BellSvg/>
        </div>
      </div>
    )
  }

  renderBasketItem () {
    return (
      <div {...{
        class: {
          'product-page-fixed__basket-button': true,
          'product-page-fixed__basket-button_success': this.isBasket
        },
        on: {
          click: this.addToBasket
        }
      }}>
        {this.isBasket &&
        <div class="product-page-fixed__basket-icon">
          <BasketSvg/>
        </div>
        }
        <div class='product-page-fixed__basket-icon-mobile'>
          {!this.isBasket ? <BasketSvg/> : <BasketSuccessSvg/>}
        </div>
        <div class="product-page-fixed__basket-text">
          {this.isBasket ? 'В корзине' : 'В корзину'}
        </div>
      </div>
    )
  }

  renderWaitingListButton () {
    return (
      <SwitchElement {...{
        props: {
          value: this.isWaitingList,
          name: 'waiting',
          label: 'Сообщим о поступлении',
          modifiers: [...['waiting'], ...this.isWaitingListModifier]
        },
        on: {
          change: async (v: boolean) => {
            await this.addToWaitingList(v)
          }
        },
        scopedSlots: {
          textPayload: () => this.scopedSlotsWaitingListButton()
        }
      }} />
    )
  }

  renderBasketPriceCol () {
    if (this.isAvailable) {
      return (
        <div class="product-page-fixed__price-basket-col">
          <div class="product-page-fixed__price-basket">
            <div class="product-page-fixed__price">
              {this.isDiscount &&
                <div class="product-page-fixed__price-discount">
                  {s(this.$store).productPage.basePrice} ₽
                </div>
              }
              <div class="product-page-fixed__price-base">
                {s(this.$store).productPage.price} ₽
              </div>
            </div>
            {this.renderBasketItem()}
            {this.isBasket &&
              <div class="product-page-fixed__bakset-selector">
                <BasketNumber {...{
                  props: {
                    id: s(this.$store).productPage.id,
                    isLarge: true
                  }
                }} />
              </div>
            }
          </div>
        </div>
      )
    } else {
      return (
        <div class="product-page-fixed__price-basket-col">
          <div class="product-page-fixed__price-basket">
            <div class="product-page-fixed__basket-text-not-available">
              Товара нет в наличии
            </div>
            {this.renderWaitingListButton()}
          </div>
        </div>
      )
    }
  }

  render () {
    return (
      <div class={{
        'product-page-fixed': true,
        'not-available': !this.isAvailable,
        'product-page-fixed__scroll': this.isScroll,
        'product-page-fixed_with-link': !!this.backLink
      }}>
        <div class="product-page-fixed__container">
          { this.backLink &&
            this.renderNavBackLink()
          }

          <div class="product-page-fixed__row">
            <div class="product-page-fixed__image-col">
              {s(this.$store).productPage.img &&
                <div class="product-page-fixed__image">
                  <ImageElement key={this.code} {...{
                    props: {
                      img: s(this.$store).productPage.img,
                      alt: s(this.$store).productPage.title
                    }
                  }} />
                </div>
              }
            </div>
            <div class="product-page-fixed__info-col">
              <div class="product-page-fixed__info">
                <div class="product-page-fixed__info-name">
                  {s(this.$store).productPage.title}
                </div>
                {s(this.$store).productPage.mnn &&
                  <div class="product-page-fixed__info-mnn">
                    MNN {s(this.$store).productPage.mnn}
                  </div>
                }
              </div>
            </div>
            {this.renderBasketPriceCol()}
          </div>
        </div>
      </div>
    )
  }
}
